import script from "./question-detail-19.vue?vue&type=script&lang=tsx&setup=true"
export * from "./question-detail-19.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__